var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as PIXI from "pixi.js";
/**
 * This mixin adds rendering capabilities
 * @param Base
 * @constructor
 */
export var MeshMixin = function (Base) {
    var Derived = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super.call(this) || this;
            _this._shader = null;
            _this._geometry = null;
            _this._state = PIXI.State.for2d();
            _this._size = 0;
            _this._start = 0;
            _this._drawMode = PIXI.DRAW_MODES.TRIANGLES;
            return _this;
        }
        Object.defineProperty(class_1.prototype, "drawMode", {
            get: function () {
                return this._drawMode;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(class_1.prototype, "state", {
            get: function () {
                return this._state;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(class_1.prototype, "start", {
            get: function () {
                return this._start;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(class_1.prototype, "size", {
            get: function () {
                return this._size;
            },
            enumerable: false,
            configurable: true
        });
        class_1.prototype._buildShader = function () {
            throw Error('To be implemented');
        };
        Object.defineProperty(class_1.prototype, "shader", {
            get: function () {
                return this._shader;
            },
            enumerable: false,
            configurable: true
        });
        class_1.prototype._buildGeometry = function () {
            throw Error('To be implemented');
        };
        Object.defineProperty(class_1.prototype, "geometry", {
            get: function () {
                return this._geometry;
            },
            enumerable: false,
            configurable: true
        });
        class_1.prototype._renderDefault = function (renderer) {
            // console.log('rendering default');
            if (!this.shader || !this.geometry) {
                console.log('no shader or geometry available. Nothing to render');
                return;
            }
            // this.shader.alpha = this.worldAlpha;
            // // if the shader has an update method, call it. This is where PIXI updates both the color
            // // and uvMatrix if dirty
            // if (this.shader.update)
            // {
            //     this.shader.update();
            // }
            renderer.batch.flush();
            // console.log('renderer', renderer.CONTEXT_UID);
            // const bufferSystem = renderer.buffer;
            // for (let i = 0; i < this.geometry.buffers.length; i++) {
            //     const buffer = this.geometry.buffers[i];
            //     const GLbuffer = buffer._glBuffers[renderer.CONTEXT_UID] || bufferSystem.createGLBuffer(buffer);
            //     // bufferSystem.update(buffer);
            // }
            this.shader.uniforms.translationMatrix = this.transform.worldTransform.toArray(true);
            // console.log('binding shader', this)
            renderer.shader.bind(this.shader, false);
            renderer.state.set(this.state);
            renderer.geometry.bind(this.geometry, this.shader);
            renderer.geometry.draw(this.drawMode, this.size, this.start, this.geometry.instanceCount);
        };
        return class_1;
    }(Base));
    return Derived;
};
